import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {FormBuilder, FormGroup} from '@angular/forms';
import {createMenu} from './favorite-link.menu.model';
import {FavoriteLinkType, findIconClassByPath} from './favorite-link-icons.model';
import {TranslateService} from '@ngx-translate/core';
import {FavoriteModel} from '../../../../../../projects/api/src/favorite/favorite.model';

const favoriteLinkType = {
  [FavoriteLinkType.dashboard]: {icon: 'in-tachometer', title: 'dashboard'},
  [FavoriteLinkType.chart]: {icon: 'in-chart-line', title: 'chart'},
  [FavoriteLinkType.map]: {icon: 'in-globe', title: 'map'},
  [FavoriteLinkType.object]: {icon: 'in-university', title: 'object'},
  [FavoriteLinkType.config]: {icon: 'in-cogs', title: 'config'},
  [FavoriteLinkType.history]: {icon: 'in-history', title: 'history'},
  [FavoriteLinkType.list]: {icon: 'in-list', title: 'list'},
  [FavoriteLinkType.users]: {icon: 'in-users', title: 'users'},
  [FavoriteLinkType.profile]: {icon: 'in-user-circle-outline', title: 'profile'},
};

export type LinkType = 'dashboard' | 'object' | 'link';

/**
 * Модальный диалог со списком страниц
 * поддерживает следубщие действия:
 * - изменение
 * - удаление
 * - переход по ссылке
 */
@Component({
    selector: 'app-favorite-link',
    templateUrl: './favorite-link.component.html',
    styleUrls: ['./favorite-link.component.scss'],
    standalone: false
})
export class FavoriteLinkComponent implements OnInit {
  @Input() favLink: FavoriteModel;
  @Output() delete = new EventEmitter<number>();
  @Output() update = new EventEmitter<FavoriteModel>();
  @Output() navigate = new EventEmitter<String>();
  @Output() edit = new EventEmitter<number>();
  @Input() type: LinkType = 'link';

  link = ``;

  public favoriteLinkForm: FormGroup;
  public items1: MenuItem[];

  constructor(private fb: FormBuilder, private ngxTranslateService: TranslateService, private element: ElementRef) {
  }

  ngOnInit() {
    this.items1 = createMenu(
      (event) => this.showEditForm(event),
      (event) => this.copyUrl(event),
      (event) => this.deleteFavLink(event),
      (event) => this.openInNewWindow(event),
      (event) => this.openInNewTab(event),
      this.ngxTranslateService
    );
    this.updateLink();
    this.createForm();
  }

  urlNavigate(event, url) {
    event.preventDefault();
    this.navigate.emit(url);
  }

  urlNavigate2(event, url, pre) {
    event.preventDefault();
    const url2 = `${window.location.origin}/${pre}/${url}`;
    window.open(url2,'_self');
  }

  updateLink() {
    switch (this.type) {
      case 'link':
        this.link = this.favLink.url;
        break;
      case 'object':
        this.link = `/app/#!/main/map/objects/${this.favLink.linkobjid}/params/`;
        break;
      case 'dashboard':
        this.link = `/app/#!/main/dashboard/${this.favLink.linkobjid}`;
        break;
    }
  }

  /**
   * Создает форму для редактирования на основе данных FavoriteLink
   */
  createForm() {
    this.favoriteLinkForm = this.fb.group(this.favLink as {[p: string]: any});
  }

  /**
   * Отображает форму для изменения ссылки
   * @param event
   */
  showEditForm(event) {
    this.edit.next(this.favLink.id);
  }

  /**
   * Копирует URL в буфер обмена
   * пока не реализовано
   * @param event
   */
  copyUrl(event) {

  }

  /**
   * Удаляет ссылку из списка избранного
   * @param event
   */
  deleteFavLink(event) {
    this.delete.next(this.favLink.id);
  }

  /**
   * Отрабатывает запрос на открытие ссылки в новом окне
   * @param event
   */
  openInNewWindow(event) {
    const link = this.type === 'link' ? this.link : window.location.origin + this.link;
    window.open(link, '_blank', 'modal=yes');
  }

  /**
   * Отрабатывает открытие ссылки в новой вкладке
   * @param event
   */
  openInNewTab(event) {
    const link = this.type === 'link' ? this.link : window.location.origin + this.link;
    window.open(link, '_blank');
  }

  /**
   * Переход по ссылке
   * @returns {boolean}
   */
  navigateTo() {
    this.navigate.next(this.link);
    return false;
  }

  navigateTo2() {
    window.open(this.favLink.url,'_self');
    return false;
  }

  /**
   * Обновляет/изменяет содержимое ссылки
   */
  updateFavLink() {
    this.update.next(this.favoriteLinkForm.value);
  }

  /**
   * Отменяет изменение содержимого ссылки (в режиме редактирования)
   */
  revert() {
    this.edit.next(undefined);
  }

  /**
   * Определяет какой класс иконки отобразить, исходя из урла
   * @returns {string}
   */
  getIconClass() {
    const data = favoriteLinkType[findIconClassByPath(this.favLink.url)];
    if (data) {
      return data.icon;
    }
    return '';
  }

  getType() {
    const data = favoriteLinkType[findIconClassByPath(this.favLink.url)];
    if (data) {
      return `favorite.${data.title}`;
    }
    return '';
  }
}
